import { render, staticRenderFns } from "./PlayingNow.vue?vue&type=template&id=36080907&"
import script from "./PlayingNow.vue?vue&type=script&lang=ts&"
export * from "./PlayingNow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports